import type { Section } from '@common/formEngine/formEngine.types';
import type { Icd10Code } from '@common/interfaces/icd10';
import type { DeepPickPath } from '@common/utils/deepPickUtils';
import type { NullablePrimitives } from '@common/utils/utilityTypes';
import { dependsOn } from '@common/formEngine/dependsOn';

export enum Beleid {
    conservatief = 'Conservatief',
    verwijzen = 'Verwijzen',
}

const beleidOptions: Beleid[] = [Beleid.conservatief, Beleid.verwijzen];

export type EchographyConsultResponseData = NullablePrimitives<{
    diagnosis_icd10: Icd10Code | null;
    diagnostische_bevinding_beleid: string;
    diagnostische_bevinding_beleid_specificatie_conservatief: string;
    diagnostische_bevinding_beleid_specificatie_verwijzen: string;
    diagnostische_bevinding_bevindingen: string;
    diagnostische_bevinding_diagnose_bekend: boolean;
    diagnostische_bevinding_toelichting: string;
    feedback_aan_huisarts: string;
}>;

export type EchographyConsultResponseKey = DeepPickPath<EchographyConsultResponseData>;

export const echographyConsultResponseSections: Section<EchographyConsultResponseData>[] = [
    {
        fields: [
            {
                isRequired: true,
                key: 'diagnostische_bevinding_bevindingen',
                label: 'Bevindingen',
                type: 'textArea',
            },
            {
                isRequired: true,
                key: 'diagnostische_bevinding_diagnose_bekend',
                label: 'Diagnose bekend',
                type: 'boolean',
            },
            {
                include: dependsOn('diagnostische_bevinding_diagnose_bekend'),
                isRequired: true,
                key: 'diagnosis_icd10',
                label: 'Diagnose',
                type: 'icd10',
            },
            {
                allowOtherOption: true,
                key: 'diagnostische_bevinding_beleid',
                label: 'Beleid',
                type: 'radioGroup',
                valueOptions: beleidOptions,
            },
            {
                include: dependsOn(
                    'diagnostische_bevinding_beleid',
                    ({ diagnostische_bevinding_beleid }) => diagnostische_bevinding_beleid === Beleid.conservatief
                ),
                key: 'diagnostische_bevinding_beleid_specificatie_conservatief',
                label: 'Specificatie conservatief',
                type: 'textArea',
            },
            {
                include: dependsOn(
                    'diagnostische_bevinding_beleid',
                    ({ diagnostische_bevinding_beleid }) => diagnostische_bevinding_beleid === Beleid.verwijzen
                ),
                key: 'diagnostische_bevinding_beleid_specificatie_verwijzen',
                label: 'Specificatie verwijzen',
                type: 'textArea',
            },
            {
                key: 'diagnostische_bevinding_toelichting',
                label: 'Toelichting',
                type: 'textArea',
            },
        ],
        title: 'Diagnostische bevinding',
    },
    {
        alertText: 'Dit wordt niet meegestuurd in het EDIFACT-bericht.',
        fields: [
            {
                key: 'feedback_aan_huisarts',
                label: 'Feedback',
                type: 'textArea',
            },
        ],
        title: 'Feedback aan huisarts',
    },
];
